import { Button } from 'structure/home/components/Button';
import { CardBase } from 'structure/home/components/CardBase';
import Image from 'next/image';
import Link from 'next/link';
import { Body1, Header1, Header4 } from 'structure/home/components/Typography';
import { getStaticAssetUrl } from 'utils/url';
import dynamic from 'next/dynamic';
import { Icon } from '@dapp/multi-lib/sdaoui/Icon';
import { TeamImage } from 'structure/home/components/TeamImage';
import { TokenAddresses } from 'structure/home/components/TokenAddreses';

const TestnetAnimation = dynamic(
  () => import('components/Testnet/TestnetAnimation'),
  {
    ssr: false,
  }
);
export const Intro = () => {
  return (
    <CardBase className='px-0 py-0'>
      <div
        className={`min:h-4/5 relative z-10 mx-auto flex w-full  flex-col-reverse items-start justify-start gap-2 pb-8 md:items-center lg:flex-row 2xl:w-full  2xl:max-w-[120rem]`}
      >
        <div className='z-11 flex grid-cols-2 flex-col items-center justify-start gap-4 max-lg:px-0 md:max-w-[500px] lg:gap-6 xl:max-w-full xl:p-4 xl:px-8'>
          <div className='relative z-10 mx-auto mb-8 flex h-full w-full'>
            <div className='flex w-full max-w-[771px] flex-col gap-3'>
              <Header1 className='text-center lg:text-left'>
                Singularity Finance
              </Header1>
              <Header4 className={`text-center text-softYellow lg:text-left`}>
                Powering the AI Economy
              </Header4>
              <Body1 className='mt-3 text-center lg:text-left'>
                Singularity Finance (SFI) is the on-chain infrastructure
                powering the AI economy. Our platform provides the foundational
                layer for AI-driven finance applications to launch, optimize,
                and scale.
              </Body1>
              <div className='mt-6 flex flex-row justify-center gap-4 lg:hidden'>
                <Button
                  component={Link}
                  href={'/vaults'}
                  style='accent'
                  className='gap-2 hover:border-[#EBEB77] hover:text-[#EBEB77] focus:border-[#EBEB77] focus:text-[#EBEB77]'
                >
                  <Icon
                    icon='vault'
                    height={24}
                    width={24}
                    color='currentColor'
                  />
                  Vaults
                </Button>
                <Button
                  component={Link}
                  href={'/staking'}
                  style='accent'
                  className='gap-2 hover:border-[#EBEB77] hover:text-[#EBEB77] focus:border-[#EBEB77] focus:text-[#EBEB77]'
                >
                  <Icon
                    icon='coins'
                    height={24}
                    width={24}
                    color='currentColor'
                  />
                  Staking
                </Button>
                <Button
                  component={Link}
                  href={'/bridge'}
                  style='accent'
                  className='gap-2 hover:border-[#EBEB77] hover:text-[#EBEB77] focus:border-[#EBEB77] focus:text-[#EBEB77]'
                >
                  <Icon
                    icon='bridge'
                    height={24}
                    width={24}
                    color='currentColor'
                  />
                  Bridge
                </Button>
              </div>
              <div className='mb-2 mt-4 flex justify-center lg:justify-start'>
                <TokenAddresses />
              </div>
              <div className='mt-2 flex flex-row justify-center gap-6 pb-14 lg:justify-start'>
                <Button
                  component={Link}
                  href='/vaults'
                  style='neutral'
                  className='hidden gap-2 text-sm lg:inline-flex'
                >
                  Explore Vaults
                </Button>
                <Button
                  component={Link}
                  href='http://docs.singularityfinance.ai'
                  style='accent'
                  className='gap-2 text-sm lg:text-xl'
                >
                  <Icon
                    icon='description'
                    height={24}
                    width={24}
                    color='currentColor'
                  />
                  Whitepaper
                </Button>
              </div>
            </div>
          </div>
        </div>
        <TestnetAnimation />
      </div>
      <div className='hidden flex-col justify-between gap-6 lg:flex-row'>
        <div className='flex basis-1/2 flex-col items-center gap-6 lg:basis-1/3 lg:items-start'>
          <Header4 className='font-normal text-[#A19E99]'>
            Founding Teams
          </Header4>
          <div className='flex flex-row gap-4 lg:gap-6'>
            <TeamImage
              src={getStaticAssetUrl('/sfi/static/homepage/sdao.svg')}
              alt='singularitydao'
              width={60}
              height={60}
            />
            <TeamImage
              src={getStaticAssetUrl('/sfi/static/homepage/cgv.svg')}
              alt='cogito'
              width={60}
              height={60}
            />
            <TeamImage
              src={getStaticAssetUrl('/sfi/static/homepage/selfkey.svg')}
              alt='selfkey'
              width={60}
              height={60}
            />
          </div>
        </div>

        <div className='flex flex-col items-center gap-6 lg:items-start'>
          <Header4 className='font-normal text-[#A19E99]'>Partner</Header4>
          <div className='flex flex-row gap-6'>
            <div className='flex h-[64px] w-[136px] justify-center rounded-full bg-[#272727] p-4 lg:h-[86px] lg:w-[186px]'>
              <Image
                src={getStaticAssetUrl(
                  '/sfi/static/homepage/singularitynet.svg'
                )}
                alt='singularitynet'
                width={154}
                height={54}
              />
            </div>
          </div>
        </div>
      </div>
    </CardBase>
  );
};
